import './SidePanelDialog.scss';

import React from 'react';

import { useVirtualRoom } from '../../../../data/hooks/ui/useVirtualRoom';
import CollectContextProvider from '../../../collect/CollectContextProvider';
import SidePanelWrapper from '../../SidePanelWrapper';

const SidePanelDialog = (props) => {
    const { className, onClose } = props,
        hasVirtualRoom = !!useVirtualRoom();

    return (
        <SidePanelWrapper>
            <CollectContextProvider context="networkarea-popup">
                <div className={['SidePanelDialog', className].join(' ')}>
                    <div className="overlay" onClick={onClose}></div>
                    <div
                        className={[
                            'dialog',
                            hasVirtualRoom ? 'has-virtual-room' : '',
                        ].join(' ')}
                    >
                        <button
                            type="button"
                            className="closeIcon"
                            onClick={onClose}
                        />
                        <section>{props.children}</section>
                    </div>
                </div>
            </CollectContextProvider>
        </SidePanelWrapper>
    );
};

export default SidePanelDialog;
